import clsx from 'clsx'
import { NavLink, Outlet } from 'react-router'

interface TabLinkProps {
  children: React.ReactNode
  to: string
}

function TabLink ({ children, to }: TabLinkProps) {
  return (
    <NavLink
      className={({ isActive }) =>
        clsx(
          'flex shrink-0 items-center rounded-t-lg',
          'body-bold',
          'bg-transparent hover:bg-gray-100',
          'border-b-2',
          'p-2 flex',
          'transition',
          {
            'border-gray-800 hover:border-gray-800 text-gray-800 hover:text-gray-800': isActive,
            'border-transparent hover:border-gray-300 text-gray-500 hover:text-gray-800': !isActive
          }
        )}
      to={to}
    >
      {children}
    </NavLink>
  )
}

export function SettingsPage () {
  return (
    <div>
      <h1 className='heading-lg mb-6'>Settings</h1>
      <div className='bg-white rounded-2xl border border-gray-200 shadow-sm'>
        <div className='border-b border-gray-200 px-4 pt-2'>
          <nav className='flex items-end gap-4 overflow-x-auto -mb-px'>
            <TabLink to='/employers/dashboard/settings/company'>Company</TabLink>
            <TabLink to='/employers/dashboard/settings/allowances'>Allowances</TabLink>
            <TabLink to='/employers/dashboard/settings/banking'>Bank Account</TabLink>
            <TabLink to='/employers/dashboard/settings/payroll'>Payroll</TabLink>
          </nav>
        </div>
        <div>
          <Outlet />
        </div>
      </div>
    </div>
  )
}
